module.exports = __webpack_public_path__ + "assets/imgs/sd-logo--new--dark.4c71427aa4b560baa29764d61a0b5037.svg";